import { useQuery } from '@tanstack/react-query';

import { adminFetch } from '@/hooks/admin/useAdminApi';

export interface GroupStatementInvoice {
  qbo_invoice_id: string;
  doc_number: string;
  txn_date: string;
  due_date: string | null;
  original: number;
  balance: number;
}

export interface GroupStatementStore {
  customer_id: string;
  name: string;
  store_code: string | null;
  is_master: boolean;
  subtotal: number;
  invoices: GroupStatementInvoice[];
}

export interface GroupStatementData {
  master: {
    customerId: string;
    name: string;
    qboCustomerId: number;
    groupBrand: string | null;
  };
  as_of_date: string;
  total_open: number;
  open_count: number;
  aging: {
    current: number;
    d1_30: number;
    d31_60: number;
    d61_90: number;
    d90plus: number;
  };
  stores_with_nothing_open: number;
  stores: GroupStatementStore[];
}

export interface GroupStatementResponse {
  is_group: boolean;
  separate_account_note?: string;
  statement: GroupStatementData | null;
}

/**
 * The merged chain statement for the caller's active account.
 *
 * `is_group: false` for an ordinary customer — the Statements page then shows
 * its normal single-account document. Same builder as the PDF download and
 * the monthly email, so all three quote one balance.
 */
export function useGroupStatement() {
  return useQuery({
    queryKey: ['group-statement'],
    queryFn: () => adminFetch<GroupStatementResponse>('customer-group-statement'),
    staleTime: 60_000,
    retry: 1,
  });
}
